import { useContext } from 'react';
import { useGetSubscriptions } from 'api/subscription';
import { UserContext } from 'context-providers/user-provider';
import { isFraudulentUser } from 'lib/member-experience';

// A one-time purchaser is a logged-in member whose subscriptions have loaded
// as empty. Fraud-flagged members are excluded so they keep the standard
// account experience. `isResolving` is true until that can be decided.
export const useIsOneTimePurchaser = (): {
  isOneTimePurchaser: boolean;
  isResolving: boolean;
} => {
  const { userState, isLoadingUser } = useContext(UserContext);
  const { data: subscriptions, isLoading } = useGetSubscriptions();

  const isLoggedIn = Boolean(userState?.email);
  const isResolving = isLoadingUser || !isLoggedIn || isLoading;
  const hasNoSubscriptions =
    Array.isArray(subscriptions) && subscriptions.length === 0;

  return {
    isOneTimePurchaser:
      !isResolving && hasNoSubscriptions && !isFraudulentUser(userState),
    isResolving,
  };
};
